<section class="main-section">
  <form>
      <div class="col">
        <div class="inner-box">
            <div class="col">
              <div class="text-center">
                <h2 class="text-black mb-3 review">Shipment View</h2>
              </div>
            </div>
          <div class="col">
            <h2 class="text-black mb-2 review">Shipment Details</h2>
            <label class="text-black"><b>Shipment#:</b><span
              class="ml-1"> {{shipmentline.id}} </span></label><br>
            <label class="text-black"><b>Shipment Date : </b><span
              class="ml-1"> {{shipmentline.createdDate}}</span></label><br>
            <label class="text-black"><b>Status : </b><span
              class="ml-1"> {{shipmentline.status}}</span></label><br>
            <label class="text-black"><b>Shipment Identifier: </b><span
              class="ml-1"> {{shipmentline.shipmentIdendifier}}</span></label><br>
            <label class="text-black"><b>No.Of Boxes: </b><span
              class="ml-1"> {{shipmentline.noOfBoxes}}</span></label><br>
            <label class="text-black"><b>Contact Name : </b><span
              class="ml-1"> {{shipmentline.accountOwnerContactName}}</span></label><br>
            <label class="text-black"><b>Address : </b><span
              class="ml-1"> {{shipmentline.addressText}}</span></label><br>
          </div>
          </div>
        <div class="row mt-3">
          <div class="col text-right">
            <button type="submit" *ngIf="user.role === 'ROLE_ADMIN'" routerLink="/admin/adminShipmentList" class="btn btn-cancel">Close</button>
            <button type="submit" *ngIf="user.role === 'ACCOUNT_OWNER'" routerLink="/admin/shipmentList" class="btn btn-cancel">Close</button>
            <button type="submit" *ngIf="user.role === 'DRIVER'" routerLink="/admin/driverShipment" class="btn btn-cancel">Close</button>
          </div>
        </div>

      </div>
  </form>
</section>
